import classNames from 'clsx';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { isPublicPasswordEnabled } from 'reactApp/appHelpers/featuresHelpers/features/publicPassword';
import { CSAT_TRIGGER_EVENTS, pushCSATTriggerEvent } from 'reactApp/modules/promo/sagas/initCSATSurvey';
import { Button, ButtonSizeMode, ButtonVariant } from 'reactApp/ui/Button/Button';

import styles from './CloseSharing.css';

interface Props {
    showSharing?: boolean;
    isOwner?: boolean;
    isPhone?: boolean;
    onClick(): void;
}

export const CloseSharing: React.FC<Props> = ({ showSharing, onClick, isOwner, isPhone }) => {
    const dispatch = useDispatch();
    const buttonProps = isPublicPasswordEnabled
        ? {
              sizeMode: ButtonSizeMode.small,
          }
        : {
              variant: ButtonVariant.contrast,
          };

    const handleCloseButtonClick = useCallback(() => {
        onClick();
        dispatch(pushCSATTriggerEvent({ type: CSAT_TRIGGER_EVENTS.closeWeblink }));
    }, [dispatch, onClick]);

    return (
        <Button
            className={classNames(styles.root, {
                [styles.contrast]: buttonProps.variant === ButtonVariant.contrast,
                [styles.root_phone]: isPhone,
            })}
            {...buttonProps}
            onClick={handleCloseButtonClick}
        >
            {showSharing && isOwner ? 'Закрыть доступ для всех' : 'Закрыть доступ'}
        </Button>
    );
};
